import { css } from "@emotion/css";

export const container = css`
  flex: 0.7;
`;
